class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isInlineHeaderSearch = this.classList.contains('custom-header-search-moved');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    if (this.isInlineHeaderSearch) {
      this.summaryToggle.addEventListener('mousedown', (event) => {
        this.inlineSearchScrollPosition = { x: window.scrollX, y: window.scrollY };
        event.preventDefault();
      });
      this.detailsContainer.addEventListener(
        'mousedown',
        (event) => {
          if (!event.target.matches('input:not([type="hidden"])')) return;
          const scrollPosition = { x: window.scrollX, y: window.scrollY };
          event.preventDefault();
          event.target.focus({ preventScroll: true });
          this.restoreInlineSearchScroll(scrollPosition);
        },
        true
      );
    }
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  restoreInlineSearchScroll(scrollPosition) {
    window.scrollTo(scrollPosition.x, scrollPosition.y);
    requestAnimationFrame(() => window.scrollTo(scrollPosition.x, scrollPosition.y));
    setTimeout(() => window.scrollTo(scrollPosition.x, scrollPosition.y), 0);
    setTimeout(() => window.scrollTo(scrollPosition.x, scrollPosition.y), 120);
    setTimeout(() => window.scrollTo(scrollPosition.x, scrollPosition.y), 280);
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (this.isInlineHeaderSearch) {
      const scrollPosition = this.inlineSearchScrollPosition || { x: window.scrollX, y: window.scrollY };
      const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
      input?.focus({ preventScroll: true });
      this.restoreInlineSearchScroll(scrollPosition);
      return;
    }

    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.isInlineHeaderSearch) {
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      if (focusToggle) this.summaryToggle.focus({ preventScroll: true });
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      this.restoreInlineSearchScroll({ x: scrollX, y: scrollY });
      return;
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
